export default __webpack_public_path__ + "static/media/Leggings of the Clay.95fece09.jpg";